/* eslint-disable */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Title } from '../style';

const CgvProfessional = () => {
  return (
    <Grid container alignItems="center" justify="center">
      <Grid item md={8} style={{ textAlign: 'center' }}>
        <Title>Condition générale de vente pour les professionnels</Title>
      </Grid>
      <Grid item md={8}>
        <h3>Préambule</h3>
        <p>
          L’Application Sympl est éditée par la société SAS DAT, société par
          actions simplifiée, immatriculée au Registre du commerce et des
          Sociétés de Paris sous le numéro 827776162, siégeant au 259, rue Saint
          Honoré — 75001 Paris, et représentée par son Président Monsieur
          Philippe Allouche, (ci-après « SYMPL »).
        </p>
        <h3>1- Glossaire & définitions</h3>
        <p>
          Les mots ci-dessous, dont la première lettre est en majuscules, seront
          définis comme tels dans les présentes conditions générales :{' '}
        </p>
        <p>
          <strong>Application :</strong> désigne l’Application logicielle Sympl,
          éditée par le Prestataire et installée sur le téléphone mobile du
          Client, à l’initiative de ce dernier.{' '}
        </p>
        <p>
          <strong>Client :</strong> personne utilisant l’un des produits
          développés par Sympl (module, site et/ou Applications). Le Client
          passe commande en son nom, ou pour le compte d’une personne morale.{' '}
        </p>
        <p>
          <strong>Conditions générales de vente :</strong> conditions
          contractuelles dans le cadre desquelles s’effectue l’intégralité du
          service proposé par SYMPL.{' '}
        </p>
        <p>
          <strong>Conditions générales d’utilisation :</strong> conditions
          d’utilisation de l’Application Sympl.{' '}
        </p>
        <p>
          <strong>Commande :</strong> désigne l’achat par le Client de la
          prestation de service proposée par SYMPL à savoir : récupération du ou
          des Objets du Client par le Coursier, son emballage par SYMPL et sa
          livraison par un Partenaire de SYMPL à l’adresse désignée par le
          Client
        </p>
        <p>
          <strong>Coursier :</strong> désigne l’entité ou la personne
          responsable du retrait de la marchandise du Client, à l’adresse qu’il
          aura indiquée{' '}
        </p>
        <p>
          <strong>Entrepôt :</strong> désigne le ou les locaux occupés par SYMPL
          dans lesquels les objets confiés par les clients sont pesés,
          conditionnés et remis aux Transporteurs.
        </p>
        <p>
          <strong>Marchandise :</strong> Objets remis par le Client en vue de
          l’utilisation des services SYMPL.
        </p>
        <p>
          <strong>Module :</strong> désigne le connecteur entre le système de
          SYMPL et celui du Client.
        </p>
        <p>
          <strong>Objet :</strong> désigne les objets, produits ou marchandises
          que les Clients font livrer en utilisant les services proposés par
          SYMPL
        </p>
        <p>
          <strong>Partenaire :</strong> désigne l’ensemble des transporteurs
          partenaires utilisés par SYMPL. Les transporteurs sont La Poste,
          Colissimo, Chronopost, DPD France, TNT, DHL, UPS, Colis Privé.,
          Assendia, Mondial Relay.Cette liste est susceptible d’évoluer. Notre
          système informatique sélectionne le partenaire adéquat en fonction des
          caractéristiques de la commande et du mode de livraison choisi par le
          Client.
        </p>
        <p>
          <strong>Politique de confidentialité :</strong> règles relatives à
          l’exploitation des données personnelles des Clients du site. La
          Politique de confidentialité détaille l’utilisation faite des données
          personnelles du Client du site, ainsi que les droits dont il dispose
          sur ces données.
        </p>
        <p>
          <strong>Prix :</strong> prix total du service proposé par SYMPL. Les
          prix sont entendus HT.
        </p>
        <p>
          <strong>Service :</strong> désigne l’ensemble des prestations fournies
          par SYMPL.
        </p>
        <p>
          <strong>Site :</strong> désigne le site app.sympl.fr
        </p>
        <p>
          <strong>Transporteur :</strong> désigne la société sélectionnée et
          mise en relation avec le Client par l’intermédiaire de SYMPL qui sera
          chargée de la livraison de ou des produits confiés de l’Entrepôt SYMPL
          à l’adresse déterminée par l’utilisateur.
        </p>
        <p>
          <strong>Validation de la commande :</strong> acceptation de la
          commande passée par le Client sur l’Application ou le module.
        </p>
        <h3>2- Champs d'application</h3>
        <p>
          Conformément aux dispositions de l’article L 441-6 du Code de
          Commerce, les présentes conditions générales de vente et d’utilisation
          constituent le socle unique de la relation commerciale entre les
          parties et s’appliquent sans restriction ni réserves à toutes les
          commandes de Service défini à l’article 3 ci-dessous passées par le
          Client sur l’application ou le module SYMPL.
        </p>
        <p>
          Les présentes conditions de vente et d’utilisation s’appliquent à
          l’exclusion de tous autres conditions. Leurs stipulations prévalent
          sur toutes mentions contraires issues des documents du Client et
          notamment de ses conditions générales d’achat.
        </p>
        <p>
          Elles ont pour objet de définir les conditions générales dans
          lesquelles SYMPL fournit son Service à ses Clients. Seules les
          stipulations des conditions particulières prévaudront, en cas de
          contradiction, sur les présentes.
        </p>
        <p>
          Elles sont accessibles à tout moment sur l’Application et le module et
          prévaudront, le cas échéant, sur toute autre version ou tout autre
          document contradictoire.
        </p>
        <p>
          Le Client est tenu d’en prendre connaissance avant toute passation de
          commande, le choix et l’achat d’un service étant de la seule
          responsabilité du Client.
        </p>
        <p>
          Le Client déclare avoir pris connaissance des présentes conditions
          générales de vente et d’utilisation de l’Application et les avoir
          acceptées en cochant la case prévue à cet effet avant la validation de
          la procédure de commande en ligne.{' '}
        </p>
        <p>
          La validation de la commande de Service par le Client vaut acceptation
          sans restriction ni réserve des présentes conditions générales de
          vente et d’utilisation.
        </p>
        <p>
          Ces conditions pouvant faire l’objet de modifications ultérieures, la
          version applicable à la Commande du Client est celle en vigueur sur
          l’Application, le site ou le Module à la date de passation de la
          Commande.
        </p>
        <p>
          Le Client reconnaît avoir la capacité requise pour contracter et
          acquérir les services proposés sur l’appli SYMPL.
        </p>
        <p>
          Si l’une des clauses s’avérait, pour quelque raison que ce soit,
          inapplicable, nulle ou non valide, le retrait de ladite disposition
          n’affecterait pas la validité et l’opposabilité des autres
          stipulations du contrat dans son ensemble.
        </p>
        <p>
          Sauf preuve contraire, les données enregistrées dans le système
          informatique du prestataire constituent la preuve de l’ensemble de la
          transaction conclue avec le Client.{' '}
        </p>
        <p>
          Les caractéristiques principales des Services sont présentées sur
          l’Application et le module SYMPL.
        </p>
        <h3>3- Informations sur le service Sympl</h3>
        <p>
          Le service Sympl a pour vocation de proposer une solution logistique à
          la demande simplifiée, en permettant aux professionnels d’externaliser
          leur système logistique.{' '}
        </p>
        <p>
          Sympl mandate au nom et pour le compte du Client, un Coursier pour
          acheminer l’Objet au sein de son Entrepôt, se charge de l’emballage de
          l’Objet puis sélectionne mandate au nom et pour le compte du Client un
          commissionnaire de transport ou un Transporteur pour livrer l’Objet à
          l’adresse de livraison indiquée par le Client.
        </p>
        <p>
          <strong>
            Sympl fournit ce Service via l’Application, le site internet et le
            module SYMPL mais n’a en aucun cas la qualité de commissionnaire de
            transport ou de transporteur.
          </strong>
        </p>
        <p>
          SYMPL propose également au Client de conserver sa marchandise en
          attente de ses instructions sur le lieu de la livraison.
        </p>
        <h3>La procédure Sympl</h3>
        <p>
          <strong>
            1. Le Client procède à la remise de ses Marchandises au Coursier.
          </strong>{' '}
          <br /> Le Client s’engage à être présent à l’adresse indiquée. S’il
          s’avérait absent, le Coursier tentera de le joindre par téléphone au
          numéro indiqué lors de la commande sur l’Application. L’attente ne
          saurait excéder cinq (5) minutes, après lesquelles le Coursier pourra
          quitter le lieu de retrait et considérer la commande comme honorée. La
          pénalité prévue à l’article 8 ci-après sera alors appliquée.
        </p>
        <p>
          Le Client s’engage à fournir ses meilleurs efforts afin de séparer les
          commandes les unes des autres. A défaut, SYMPL se réserve le droit
          d’en refuser la collecte. SYMPL décline toute responsabilité quant à
          une éventuelle erreur effectuée dans les envois de commande dès lors
          qu’elle serait la conséquence directe d’un défaut d’individualisation
          des produits du Client.
        </p>
        <p>
          Le Client s’engage à fournir des informations justes et réelles sur
          ses marchandises, notamment (sans que cette liste soit exhaustive) sur
          la quantité et la valeur des produits. Le Client s’engage à ne pas
          demander l’exécution des Services proposés par SYMPL pour des produits
          interdits par l’article 8 des présentes Conditions générales de vente
          et d’utilisation.
        </p>
        <p>
          <strong>
            2. La Marchandise est acheminée au sein de l’Entrepôt de SYMPL, qui
            procèdera à son emballage. SYMPL s’engage à fournir ses meilleurs
            efforts afin d’assurer un emballage adapté sur mesure à la commande.
          </strong>
        </p>
        <p>
          <strong>
            3. Le cas échéant la marchandise est stockée dans les locaux de
            SYMPL dans l’attente des instructions de son mandant.
          </strong>
        </p>
        <p>
          <strong>
            4. Le Transporteur achemine le colis à la destination indiquée par
            le Client sur l’Application ou le module. Le Client s’engage à
            fournir des adresses précises et réelles de destination. SYMPL ne
            pourra être tenu responsable en cas d’échec de livraison d’un de ses
            partenaires. Si l’adresse correspond à celle d’un professionnel, au
            moins un membre du personnel doit être présent aux heures normales
            de bureau pour réceptionner l’envoi.
          </strong>
        </p>
        <p>
          <strong>
            Dès la prise en charge de l’Objet par le Transporteur un message
            sera adressé au Client pour lui indiquer le nom du partenaire, son
            site et les références avec lesquelles il pourra suivre l’évolution
            de la livraison de son Objet.
          </strong>
        </p>
        <p>
          <strong>
            Si pour une raison indépendante de la volonté du transporteur, la
            livraison ne pouvait pas être réalisée, notamment l’absence de
            destinataire à l’adresse indiquée, un avis de passage sera déposé
            sur lequel sera indiqué le lieu où l’Objet pourra être retiré. A
            défaut de retrait de l’Objet dans un délai de 10 jours à compter du
            dépôt de l’avis de passage, l’Objet sera réexpédié dans les locaux
            de SYMPL. Le Client pourra lors venir de récupérer sous réserve de
            régler les pénalités prévues à l’article 8 ci-dessous.
          </strong>
        </p>
        <p>
          <strong>
            Si l’Objet venait à ne pas être réclamé ni récupéré dans un délai de
            6 mois à compter de sa restitution à SYMPL, SYMPL est d’ores et déjà
            autorisé à le détruire ou le vendre.{' '}
          </strong>
        </p>
        <h3>LIVRAISONS INTERNATIONALES</h3>
        <p>
          Les commandes présentées sur l’Application SYMPL peuvent être envoyées
          vers tous les pays du Monde.
          <br />
          Des droits de douanes ou autres taxes locales ou droits d’importation
          ou taxes d’état sont susceptibles d’être exigibles. Ils seront à la
          charge et relèvent de la seule responsabilité du Client.
        </p>
        <h3>4 - Engagements du Client</h3>
        <p>Le Client s’engage à :</p>
        <ul>
          <li>
            - se conformer aux dispositions des présentes Conditions générales .{' '}
          </li>
          <li>
            - respecter les lois et règlements en vigueur dans tous les pays
            concernés par le transport des produits acheminés par les Services
            de SYMPL.
          </li>
          <li>
            - fournir les informations exactes nécessaires à l’utilisation de
            l’Application, pour son compte, comme tout tiers empruntant ses
            données. Toutes les données récoltées sur l’Application relative à
            l’exécution des Services constituent des preuves recevables et
            opposables entre les parties dans le cadre d’une procédure
            judiciaire.
          </li>
          <li>
            - n’entraver aucun droit de propriété intellectuelle de tiers.
          </li>
          <li>
            - ne pas usurper l’identité d’un autre Client de l’Application, et à
            respecter la vie privée d’autrui.
          </li>
          <li>
            - ne pas porter atteinte à l’intégrité de l’Application, et à ne pas
            collecter d’informations personnelles sur un autre Client.
          </li>
          <li>
            - payer les sommes dues suite à sa commande. Le Client est
            responsable du paiement de sa commande. Le Client est également
            responsable du paiement effectué pour le compte d’un mineur, ou d’un
            tiers.
          </li>
          <li>
            - ne faire qu’un usage strictement personnel des Services de SYMPL.
            La revente des Services à un tiers est strictement prohibée.
          </li>
          <li>
            - ne pas divulguer à des tiers les noms et mots de passe d’autres
            clients; ces éléments étant strictement personnels.
          </li>
          <li>
            - ne pas céder ou transférer le compte Client, nom du Client et mot
            de passe, à un tiers, personne physique ou morale.
            <strong>
              La confidentialité et la fiabilité du mot de passe et du nom du
              Client sont de l’unique responsabilité du Client.
            </strong>
          </li>
          <li>
            - à fournir toute preuve d’identité si SYMPL le juge raisonnablement
            opportun et nécessaire.
          </li>
          <li>
            - utiliser l’Application et le module en conformité avec sa
            finalité.
          </li>
          <li>
            - ne pas utiliser le Service à des fins de nuisance envers un tiers.
          </li>
          <li>
            - ne pas copier ou distribuer le contenu de SYMPL, de quelque
            manière que ce soit, sans avoir préalablement obtenu l’accord écrit
            de ses dirigeants.
          </li>
        </ul>
        <h3>5 - Prix et modalités de paiement</h3>
        <h3>5.1. DETERMINATION DU PRIX DE LA LIVRAISON</h3>
        <p>
          SYMPL propose un service de logistique pour un prix dégressif en
          fonction du nombre de colis envoyés par le Client selon les modalités
          disponibles sur l’Application ou à l’adresse http://www.sympl.fr/ prix
          (les prix sont indicatifs, sont susceptibles d’évolution, et ne
          comprennent pas le tarif du Transporteur).
        </p>
        <p>
          Les Services proposés par SYMPL sont fournis aux tarifs en vigueur sur
          le site internet lors de l’enregistrement de la commande. Le prix
          varie selon le poids réel ou volumétrique des produits après la mise
          sous carton et les informations saisies par le Client, notamment sur
          le choix d’envoi standard ou express, et le nombre de colis envoyés.
        </p>
        <h3>5.1.1. Détermination du prix estimatif :</h3>
        <p>
          Le prix estimatif communiqué au Client préalablement à la validation
          de sa commande est présenté sous forme de fourchette (prix minimum
          estimé – prix maximum estimé). Le prix estimatif est déterminé en
          fonction des informations qui ont été communiquées par le Client :
          poids, dimensions et photo. Le prix est donc susceptible de varier
          au-delà de la fourchette estimée s’il s’avérait que les indications
          renseignées dans l’Application étaient erronées.
        </p>
        <h3>5.1.2. Détermination du prix définitif</h3>
        <p>
          Le prix définitif est calculé dès son arrivée dans l’Entrepôt de SYMPL
          en fonction des dimensions exactes et du poids de l’objet transporté.
        </p>
        <p>
          La facture est simultanément adressée au Client et précise les
          éléments qui ont servi à la détermination du prix.
        </p>
        <p>
          Le Client recevra une facture par commande sauf stipulation contraire
          des conditions particulières conclues entre les Parties. SYMPL
          garantit la stricte confidentialité des données bancaires transmises.
          SYMPL s’engage à n’en faire aucun usage de quelque nature que ce soit.
        </p>
        <h3>5.2. DETERMINATION DU PRIX DU STOCKAGE</h3>
        <p>
          Le prix du stockage de la marchandise est déterminé en fonction d’un
          tarif journalier. Le prix est fixé dans les conditions particulières
          conclues entre SYMPL et le Client et est facturé au Client à la fin de
          chaque mois.
        </p>
        <h3>5.3. MODALITE DE REGLEMENT</h3>
        Le prix est payable comptant en totalité au jour de la passation de la
        commande par le Client par voie de paiement sécurisé par carte bancaire
        sauf stipulation contraire des conditions particulières.
        <br />
        Les données de paiement sont échangées en mode crypté grâce au protocole
        HTTPS.
        <br />
        Une somme égale à la fourchette haute du prix estimatif est bloquée sur
        le compte bancaire du Client au moment de la validation de la commande.
        <br />
        Le prix du Service est effectivement encaissé au moment de la
        détermination du prix définitif et de l’émission de la facture.
        <br />
        Le prestataire ne sera pas tenu de procéder à la fourniture des services
        commandés par le Client si le prix ne lui a pas été préalablement réglé
        en totalité dans les conditions ci-dessus indiquées.
        <br />
        Les paiements effectués par le Client ne seront considérés comme
        définitifs qu’après encaissement effectif des sommes dues.
        <h3>5.4. RETARD DE PAIEMENT - PENALITE</h3>
        <p>
          En cas de retard de paiement et de versement des sommes dues à SYMPL
          au delà des délais fixés ci-dessus et/ou dans les conditions
          particulières, des pénalités de retard égales au taux d’intérêt
          appliqué par la Banque Centrale Européenne à son opération de
          refinancement la plus récente majoré de DIX (10) points de pourcentage
          du montant TTC du prix figurant sur ladite facture, seront
          automatiquement et de plein droit acquises à SYMPL sans formalité
          aucune ni mise en demeure préalable.
        </p>
        <p>
          Enfin, une indemnité forfaitaire pour frais de recouvrement, d’un
          montant de 40 € sera due en supplément, de plein droit et sans
          notification préalable en cas de retard de paiement.{' '}
        </p>
        <p>
          SYMPL se réserve le droit de demander au Client une indemnisation
          complémentaire si les frais de recouvrement effectivement engagés
          dépassaient ce montant, sur présentation des justificatifs.
        </p>
        <p>
          La prolongation d’un défaut de paiement d’une facture plus d’un mois
          après sa date entraîne :{' '}
        </p>
        <p>
          De plein droit et à la discrétion de SYMPL la suspension de toute
          prestation ultérieure;
          <br />
          L’exigibilité immédiate et de plein droit de toutes autres factures
          non encore échues, avec application de l’intérêt de retard précité à
          compter de la date d’exigibilité immédiate ;
          <br />
          A compter de l’intervention de tout auxiliaire de justice ou
          juridiction, l’application d’une indemnité forfaitaire de 15% de
          l’ensemble des sommes dues à titre de clause pénale, sans préjudice de
          tous dommages et intérêts.
          <br />
          Il est précisé qu’un règlement n’est réputé effectué que par son
          encaissement effectif au crédit du compte bancaire de SYMPL, et à
          compter de celui-ci. La remise de tout effet de commerce ou promesse
          équivalente de paiement ne constitue pas un règlement au sens du
          présent article.
        </p>
        <h3>6- Réalisation de la prestation</h3>
        <p>
          La livraison est assurée par les transporteurs sélectionnés par SYMPL
          dans les délais déterminés en fonction des options choisies.
        </p>
        <h3>7 – Refus légitime de commande</h3>
        <p>
          SYMPL se réserve le droit de refuser le traitement de certaines
          commandes, notamment si elles émanent d’un Client insolvable et/ou
          avec lequel SYMPL a précédemment rencontré des différents dans le
          paiement de ses Services.{' '}
        </p>
        <p>
          Il en est de même en cas de violation des présentes Conditions
          générales. SYMPL se réserve le droit de refuser le traitement de
          commandes si, malgré ses efforts, elle est dans l’impossibilité de
          permettre l’acheminement des colis, notamment du fait d’un cas de
          force majeure imprévisible, irrésistible, extérieure.
        </p>
        <p>
          SYMPL se réserve également le droit de ne pas traiter les commandes
          relevant d’une tentative de fraude, ou du transport d’objets illicites
          tels que définis ci-dessous. SYMPL se réserve le droit de refuser le
          traitement des commandes dont les informations requises révélaient la
          présence de propos injurieux, inacceptables, ou illégaux.
        </p>
        <p>
          <strong>
            SYMPL informe son Client que ne pourront être pris en charge, sans
            que cette liste soit exhaustive :{' '}
          </strong>
        </p>
        <ul>
          <li>
            les bijoux et articles d’horlogerie composés même partiellement de
            pierres et métaux précieux,
          </li>
          <li>les pierres et métaux précieux, </li>
          <li>
            les monnaies, devises, billets de banque, valeurs financières,
            titres ou moyens de paiement et notamment les effets de commerce,
            les cartes téléphoniques, chèques cadeaux, ou tout autres support
            permettant un paiement fongible,{' '}
          </li>
          <li>
            - l’intégralité des articles relevant des dispositions des
            règlementations nationales et internationales sur les produits
            dangereux comme, sans que cette liste soit exhaustive: les gaz,
            munitions, matières inflammables, radioactives, toxiques,
            infectieuses ou corrosives,{' '}
          </li>
          <li>les animaux ou êtres vivants ou morts,</li>
          <li>les marchandises soumises à une certaine température,</li>
          <li>les denrées périssables,</li>
          <li>les armes à feu ou armes de guerre ou de collection,</li>
          <li>les objets d’art ou antiquités,</li>
          <li>
            - tout objet qui, par leur conditionnement ou nature, sont
            susceptibles de présenter un danger pour le personnel de transport
            ou de logistique,
          </li>
          <li>les véhicules ou engins de transport, les tiers,</li>
          <li>
            les supports audiovisuels interdits par toute loi ou règlementation
            applicable,
          </li>
          <li>- tout produit contrefait ou issu de la contrefaçon,</li>
          <li>les objets immoraux,</li>
          <li>les médicaments,</li>
          <li>- le tabac,</li>
          <li>les stupéfiants,</li>
          <li>les matières psychotropes,</li>
          <li>les cendres ou reliques funéraires.</li>
          <li>
            En cas de violation de l’une de ces dispositions, SYMPL se réserve
            le droit d’abandonner l’acheminement de tout colis, et le Client
            s’engage à indemniser SYMPL de toutes les conséquences résultant de
            cette violation dans les conditions prévues à l’article 8 ci-après.
          </li>
        </ul>
        <h3>8. Durée</h3>
        La prestation de livraison unique a une durée ponctuelle. En revanche,
        la prestation de stockage est conclu pour une période indéterminée.
        <br />
        SYMPL pourra y mettre fin sans juste motif en respectant un préavis de
        HUIT (8) jours ouvrés à compter de l’envoie d’un courrier recommandé
        avec accusé de réception par SYMPL.
        <br />
        Le Client pourra résilier le présent contrat en respectant un préavis de
        HUIT (8) jours ouvrés.
        <br />
        Dans ce cas, le client s’engage irrévocablement à régler à SYMPL le
        montant de l’indemnité prévue à l’article 9 ci-dessous.
        <h3>9. Pénalités</h3>
        <p>
          Dans tous les cas de refus de commande au départ du destinataire ou à
          l’Entrepôt SYMPL, dans les conditions visées ci-dessus, une pénalité
          forfaitaire égale au coût du service SYMPL multipliée par le nombre
          d’objets à récupérer simultanément à la même adresse sera appliquée au
          Client. Le coût du service SYMPL est précisé dans les conditions
          particulières.
        </p>
        <p>
          En cas d’impossibilité de livrer du transporteur dû à la faute ou la
          négligence du Client (notamment, absence de destinataire et
          d’instructions pour nouvelle présentation) : le prix de la commande
          restera acquis à SYMPL majorée du montant des frais de retour facturé
          par le Transporteur par Objet que le Client devra régler afin que son
          ou ses Objet(s) lui soit restitué.
        </p>
        <h3>10. Rétractation, modification, annulation de la commande</h3>
        <p>
          Compte tenu de la nature du service fourni, le Client reconnaît être
          informé par les présentes Conditions générales, qu’en vertu des
          dispositions de l’article L. 121-20-4 du Code de la consommation, les
          Services de transport proposés par SYMPL ne sont pas soumis au droit
          de rétractation prévu aux articles L. 121-20 et suivants du même Code.
          Les présentes Conditions générales régissent toute rétractation,
          modification ou annulation de la commande effectuée sur l’Application
          ou le module.
        </p>
        <p>
          Toute annulation ou modification survenue plus d’un quart d’heure
          après la commande du Coursier entrainera la facturation d’une pénalité
          de CINQ (5) euros par objet.{' '}
        </p>
        <p>
          Les commandes ne pourront être ni annulées ni modifiées après la prise
          en charge des colis par le Partenaire sauf information contraire
          communiqué par le transporteur après sa mise en relation avec le
          Client. Dans ce cas, toute modification de la commande est susceptible
          d’en modifier le prix. En procédant à la modification de sa commande,
          le Client est réputé accepter le nouveau calcul de prix. L’annulation
          ou la modification de la commande n’est effective que lorsque le
          Client en aura reçu une confirmation dans l’Application ou par
          courriel. En aucun cas SYMPL pourrait être tenue pour responsable en
          cas d’impossibilité de modification de commande.
        </p>
        <h3>11. Assurances & limitations de responsabilité</h3>
        <h3>11.1. LA LIVRAISON</h3>
        <p>
          <strong>
            En cas de perte, ou de dommage avéré du colis SYMPL s’engage, sur
            présentation de factures et de toute pièce justificative (photos des
            colis endommagés, déclaration de perte ou de vol, sans que cette
            liste soit exhaustive), à rembourser à son Client la valeur du ou
            des Objet(s) dans la limite trois cent (300) Euros par Commande sans
            frais aucun.
          </strong>
        </p>
        <p>
          <strong>
            Pourront seuls être indemnisés dans les conditions du présent
            article les pertes et dommages directs causés aux biens ce qui
            exclue le dédommagement des pertes de chance ou perte de gain.
          </strong>
        </p>
        <p>
          <strong>
            Pour tout colis de valeur supérieure à trois cent (300) Euros, le
            Client peut choisir de souscrire une assurance supplémentaire, dont
            le montant est calculé selon un (1) pourcentage (%) de la valeur
            totale du colis. En cas de perte, et sur présentation d’une facture,
            le Client se verra rembourser à hauteur de la valeur déclarée pour
            cet envoi.
          </strong>
        </p>
        <p>
          SYMPL décline toute responsabilité relative à une erreur de saisie ou
          une insuffisance dans les informations communiquées par le Client ou
          insuffisance des garanties souscrites.
        </p>
        <p>
          SYMPL ne saurait être tenu responsable de la discontinuité de
          fonctionnement de son Application, en cas de modification, de
          piratage, de difficulté technique, d’erreurs, de bugs, d’anomalies,
          qui ne sauraient engager sa responsabilité civile ou pénale.
        </p>
        <p>
          SYMPL ne peut garantir la compatibilité de son Application avec un
          matériel ou des installations à configuration particulière. Aucun
          dysfonctionnement imputable à des installations incompatibles ou des
          logiciels de tiers ne saurait engager la responsabilité de SYMPL.
        </p>
        <p>En cas de survenance d’un sinistre, le Client s’engage :</p>
        <ul>
          <li>
            - à indiquer sur le document présenté par le transporteur lors de la
            livraison toutes les réserves, décrire les dommages, préciser la
            date le lieu,
          </li>
          <li>
            - à en informer SYMPL dans les 48 heures de la livraison par lettre
            recommandée avec accusé de réception accompagné de tous les
            justificatifs et références nécessaires, afin que SYMPL en avertisse
            immédiatement son partenaire. Le fait que SYMPL se présente comme
            intermédiaire entre le Client, le Coursier, le Logisticien et le
            Transporteur ne saurait engager sa responsabilité de quelque manière
            que ce soit.
          </li>
        </ul>
        <p>
          Nonobstant ces considérations, SYMPL s’engage à fournir ses meilleurs
          efforts en vue de faire assurer l’exécution de la commande du Client,
          et d’apporter la solution adaptée à la mauvaise exécution ou
          l’inexécution des prestations de ses partenaires, sans que ses efforts
          ne s’analysent comme constitutifs de l’engagement d’une responsabilité
          de quelque nature que ce soit.
        </p>
        <h3>11.2. LE STOCKAGE</h3>
        <p>
          SYMPL décline toute responsabilité résultant de dommages ou
          détériorations subies par les produits périssables qui auraient été
          remis à SYMPL en vue de leur stockage préalablement à leur livraison.
        </p>
        <p>
          En cas de perte, de vol ou de sinistre (incendie, dégât des eaux…)
          ayant affecté les produits non périssables confiés à SYMPL, ce dernier
          s’engage, sur présentation de factures et de toute pièce justificative
          (photos des colis endommagés, déclaration de perte ou de vol, sans que
          cette liste soit exhaustive), à rembourser à son Client la valeur du
          stock confié dans la limite totale de 100.000 € (100.000 €) Euros.
        </p>
        <p>
          Pourront seuls être indemnisés dans les conditions du présent article
          les pertes et dommages directs causés aux biens ce qui exclue le
          dédommagement des pertes de chance ou perte de gain.
        </p>
        <p>
          Lorsque la valeur des produits confiés par le Client à SYMPL est
          supérieure CENT MILLE (100.00 €), le Client peut choisir de souscrire
          une assurance supplémentaire, dont le montant est calculé selon un (1)
          pourcentage (%) de la valeur totale du colis. En cas de perte, vol ou
          détérioration, et sur présentation d’une facture, le Client se verra
          rembourser à hauteur de la valeur déclarée pour cet envoi.
        </p>
        <h3>11.3. SINISTRE RELATIF AU FONCTIONNEMENT DE L’APPLICATION</h3>
        <p>
          SYMPL décline toute responsabilité relative à une erreur de saisie ou
          une insuffisance dans les informations communiquées par le Client ou
          insuffisance des garanties souscrites.
        </p>
        <p>
          SYMPL ne saurait être tenu responsable de la discontinuité de
          fonctionnement de son Application, en cas de modification, de
          piratage, de difficulté technique, d’erreurs, de bugs, d’anomalies,
          qui ne sauraient engager sa responsabilité civile ou pénale.
        </p>
        <p>
          SYMPL ne peut garantir la compatibilité de son Application avec un
          matériel ou des installations à configuration particulière. Aucun
          dysfonctionnement imputable à des installations incompatibles ou des
          logiciels de tiers ne saurait engager la responsabilité de SYMPL.
        </p>
        <p>
          SYMPL décline toute responsabilité résultant d'éventuels dommages
          découlant de l'utilisation (ou de l'incapacité à utiliser) de
          l’Application, y compris des dommages causés par des logiciels
          malveillants, des virus ou par une quelconque inexactitude ou omission
          d'informations, sauf si les dommages découlent d'un acte délibéré ou
          d'une grave négligence de SYMPL.
        </p>
        <p>
          Par ailleurs, SYMPL décline toute responsabilité résultant de dommages
          découlant de l'utilisation (ou de l'incapacité à utiliser) des moyens
          électroniques de communication avec l’Application, notamment les
          dommages découlant d'un échec ou d'un retard de transmission de
          communications électroniques, d'une interception ou d'une manipulation
          de communications électroniques par des tiers ou par des programmes
          informatiques utilisés pour des communications électroniques et la
          transmission de virus.
        </p>
        <h3>12. Code promotionnel</h3>
        <p>
          SYMPL peut à sa seule discrétion et selon ses conditions propres,
          décider d’octroyer des codes promotionnels en vue de la réduction du
          coût des Services proposés.
          <br />
          Ces codes promotionnels peuvent être octroyés aux Clients des Services
          de SYMPL, comme à de nouveaux Clients. Le refus d’octroi d’un tel
          code, pour des raisons relevant de l’entière discrétion de SYMPL, ne
          saurait donner lieu à compensation ou indemnisation.
        </p>
        <h3>13. Loi applicable et compétence juridictionnelle</h3>
        <p>
          Les présentes Conditions générales sont régies par la loi française.
          Le Client qui souhaiterait assigner pour quelque raison que ce soit,
          s’engage à en informer préalablement SYMPL, et de fournir ses
          meilleurs efforts en vue de régler le litige à l’amiable. Si aucun
          accord ne s’avère envisageable, les litiges seront portés devant le
          Tribunal de commerce de Paris.
        </p>
        <h3>14. Propriété intellectuelle</h3>
        <p>
          L’intégralité des éléments de l’Application et, notamment, sans que
          cette liste soit exhaustive, les photographies, graphiques, images,
          codes, mises en forme, textes, illustrations, arborescences, relèvent
          de la propriété intellectuelle exclusive de SYMPL ou SAS DAT.
        </p>
        <p>
          En vertu des dispositions de l’article L. 122-4 du Code de la
          propriété intellectuelle, et que ce soit à titre commercial ou non, la
          représentation, rediffusion, imbrication ou reproduction, intégrale ou
          partielle, et, plus généralement, toute exploitation non autorisée, et
          œuvre dérivée, de l’intégralité des éléments de l’Application, sont
          illicites.
        </p>
        <p>
          « SYMPL » est une marque déposée. Toute Utilisation de son nom, ou son
          logo, nécessite l’accord préalable de ses titulaires, sous peine
          d’Application des articles L. 713-2 et suivants du Code de la
          propriété intellectuelle.
        </p>
        <p>
          Le Client s’engage à respecter l’intégralité des droits de propriété
          intellectuelle de SYMPL s’expose à des poursuites judiciaires, et
          notamment à la caractérisation du délit de contrefaçon (sans que ce
          dernier soit exhaustif) dont les peines sont reportées aux articles L.
          335-2 et suivants du Code de la propriété intellectuelle, et engage sa
          responsabilité civile comme pénale.
        </p>
        <p>
          SYMPL informe son Client que les données nécessairement récoltées pour
          l’exécution de ses Services ne seront pas transférées en dehors du
          territoire de l’Union Européenne.
        </p>
        <p>
          SYMPL informe son Client qu’il a pris toutes les précautions utiles à
          la récolte de ces données à caractère personnel, et qu’elles sont
          conservées dans des conditions optimales de sécurité et dans le
          respect de toutes les dispositions légales et règlementaires en
          vigueur au moment de votre commande.
        </p>
        <p>
          Nous traitons ce type de données de façon loyale et licite et en
          respectant vos droits.
        </p>
        <h3>15. Loi informatique et liberté</h3>
        <p>
          En application de la loi n°78-17 du 6 janvier 1978 modifiée par la loi
          du 6 août 2004 dite « Informatique et Libertés », il est rappelé que
          les données nominatives qui sont demandées au Client sont nécessaires
          au traitement de sa commande et à l’établissement des factures,
          notamment.
        </p>
        <p>
          Ces données peuvent être communiquées aux éventuels partenaires du
          Vendeur chargés de l’exécution, du traitement, de la gestion et du
          paiement des commandes.
          <br />
          <br />
          Le traitement des informations communiquées par l’intermédiaire de
          l’application SYMPL a fait l’objet d’une déclaration auprès de la CNIL
          (déclaration n° 1873271 v 0).
          <br />
          <br />
          SYMPL récolte de manière loyale les données de son Client.
          <br />
          <br />
          SYMPL informe son Client qu’elle ne recueille aucune donnée dite «
          sensible » faisant apparaître de façon directe ou indirecte, ses
          origines raciales, ethniques, opinions politiques, philosophiques,
          religieuse, comme les données relatives à sa santé ou sa vie sexuelle,
          ainsi que toute appartenance syndicale.
          <br />
          <br />
          Le Client est informé et accepte que certaines de ses données
          personnelles soient récoltées en vue de la stricte exécution des
          Services qu’il a expressément commandés.
          <br />
          <br />
          En commandant sur l’Application via les formulaires proposés, le
          Client consent à la récolte et au traitement des données personnelles
          qu’il inscrit volontairement.
          <br />
          <br />
          Le responsable du traitement de ces données personnelles est SYMPL.
          <br />
          <br />
          Le traitement de ces données personnelles est exclusivement destiné à
          mieux vous connaître afin de permettre l’exécution des Services
          volontairement et expressément commandés par le Client, à savoir la
          proposition d’une solution logistique à la demande simplifiée, en
          permettant aux professionnels et aux particuliers d’externaliser leur
          système logistique.
          <br />
          <br />
          Aucune donnée à caractère personnel ne sera recueillie sans votre
          accord exprès et préalable. Votre accord est réputé exprès après le
          clic validant votre commande, après validation des présentes
          Conditions générales.
          <br />
          <br />
          Les données sont exclusivement destinées aux membres de SYMPL, afin de
          permettre la bonne exécution de ses Services.
          <br />
          <br />
          SYMPL informe son Client que ses données à caractère personnel ne sont
          récoltées que pour une durée n’excédant pas la finalité de la
          collecte.
        </p>
        <p>
          Conformément à la loi informatique et liberté du 6 janvier 1978, le
          Client dispose à tout moment d’un droit d’accès, de rectification et
          d’opposition à l’ensemble de ses données personnelles en écrivant par
          courrier et en justifiant de son identité à :
        </p>
        <p>
          <strong>
            SAS DAT, <br />
            259, rue Saint Honoré
            <br />
            75001 Paris
          </strong>
        </p>
      </Grid>
    </Grid>
  );
};

export default CgvProfessional;
